/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duplicate_User_PlanningsInputs */



/**
* | output |
* | --- |
* | "Duplicate user plannings" |
*
* @param {Duplicate_User_PlanningsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplicate_user_plannings = /** @type {((inputs?: Duplicate_User_PlanningsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_User_PlanningsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Duplicate user plannings")
	return /** @type {LocalizedString} */ ("Dupliquer des plannings utilisateurs")
});